import isObjectLike from 'lodash/isObjectLike';
import isArrayLikeObject from 'lodash/isArrayLikeObject';
export default function isObjectLiteral(input) {
  return isObjectLike(input) && !isArrayLikeObject(input);
}